import {
  ChangeDetectorRef,
  Component, EventEmitter, forwardRef, Input, Output
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

const UI_RELATIONAL_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RelationalComponent),
  multi: true
};

@Component({
  selector: 'lke-relational',
  template: `<div class="relational_wrapper">
  <div class="input_wrapper"
       [class.vertical]="layout === 'vertical'">
    <div class="relational_group" [class.vertical]="layout === 'vertical'">
      <span class="relational_label">
        {{ sourceLabel }}
      </span>
      <span class="relational_input">
        <auto-complete
          [(ngModel)]="source"
          [bindingProperty]="bindingProperty"
          [list]="list"
          [template]="template"
          [placeholder]="sourcePlaceholder"
          (queryChange)="queryChange.emit($event)">
            </auto-complete>
      </span>
    </div>
    <div class="relational_illustration"
         [class.horizontal]="layout === 'horizontal'">
      <div class="swap_wrapper"
           [class.horizontal]="layout === 'horizontal'"
           *ngIf="swapOn">
        <button (click)="swapValues([target, source])">
          <icon name="swap" size="20" stroke></icon>
        </button>
      </div>
      <icon *ngIf="layout === 'vertical'" name="arrow_down" size="20" stroke class="relational_direction"></icon>
    </div>
    <div class="relational_group" [class.vertical]="layout === 'vertical'">
      <span class="relational_label">
        {{ targetLabel }}
      </span>
      <span class="relational_input">
        <auto-complete
          [(ngModel)]="target"
          [bindingProperty]="bindingProperty"
          [list]="list"
          [template]="template"
          [placeholder]="targetPlaceholder"
          (queryChange)="queryChange.emit($event)">
            </auto-complete>
      </span>
    </div>
  </div>
</div>
`,
  styles: [`.relational_wrapper{position:relative}.relational_wrapper .input_wrapper{display:flex}.relational_wrapper .input_wrapper.vertical{flex-direction:column}.relational_wrapper .input_wrapper .relational_group{flex:1}.relational_wrapper .input_wrapper .relational_group.vertical{display:flex;min-height:38px}.relational_wrapper .input_wrapper .relational_group.vertical .relational_label{flex:0 0 25%;align-self:center;text-align:right;margin-right:10px}.relational_wrapper .input_wrapper .relational_group.vertical .relational_input{flex:1}.relational_wrapper .input_wrapper .relational_group .relational_label{font-weight:700}.relational_wrapper .input_wrapper .relational_illustration{margin-left:25%;position:relative}.relational_wrapper .input_wrapper .relational_illustration.horizontal{margin-left:0;align-self:flex-end;text-align:center;flex:0 0 15%}.relational_wrapper .input_wrapper .relational_illustration.horizontal icon.relational_direction{display:block;position:relative;bottom:7px}.relational_wrapper .input_wrapper .relational_illustration.horizontal .swap_wrapper{top:-21px;width:100%;left:0}.relational_wrapper .input_wrapper .relational_illustration.horizontal .swap_wrapper button{margin:0 auto}.relational_wrapper .swap_wrapper{position:absolute;display:flex;align-items:center;height:100%;top:0;right:-35px}.relational_wrapper .swap_wrapper.horizontal{top:20%}.relational_wrapper .swap_wrapper button{border:0;padding:5px;border-radius:3px;background:0 0;cursor:pointer;transition:all ease-in-out .3s}.relational_wrapper .swap_wrapper button:active,.relational_wrapper .swap_wrapper button:focus{outline:0}.relational_wrapper .swap_wrapper button:hover{background:#0081e3;color:#fff}`],
  providers: [UI_RELATIONAL_CONTROL_VALUE_ACCESSOR]
})
export class RelationalComponent implements ControlValueAccessor {

  @Input() template: string;
  @Input() sourcePlaceholder: string;
  @Input() targetPlaceholder: string;
  @Input() bindingProperty: string;
  @Input() list: Array<any>;
  @Input() sourceLabel: string;
  @Input() targetLabel: string;
  @Input() layout: 'vertical' | 'horizontal';
  @Input() swapOn: boolean = false;
  @Output() queryChange: EventEmitter<string> = new EventEmitter();
  private _source: any;
  private _target: any;

  constructor(private _detectorRef: ChangeDetectorRef) {}

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  set source(sourceValue) {
    this._source = sourceValue;
    this.onChangeCallback([sourceValue, this._target]);
  }

  set target(targetValue) {
    this._target = targetValue;
    this.onChangeCallback([this._source, targetValue]);
  }

  get source(): any {
    return this._source;
  }

  get target(): any {
    return this._target;
  }

  writeValue(obj: [any, any]): void {
    this._source = obj[0];
    this._target = obj[1];
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  swapValues(obj: [any, any]): void {
    this.queryChange.emit('');
    setTimeout(() => {
      this._source = obj[0];
      this._target = obj[1];
      this.onChangeCallback([this._source, this._target]);
      this._detectorRef.markForCheck();
    }, 0);
  }
}
